module.exports = __webpack_public_path__ + "static/img/service_introduce_5121_zh_h5.45bc0f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_5121_zh_h5.png
// module id = w5e3
// module chunks = 34